import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type GetIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGetData,
  type GetIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGetError,
  type GetIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGetResponse,
  getIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGet,
} from '../../generated';

export type GetIdeaQueryVariables = GetIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGetData['path'];

export type GetIdeaQuery = GetIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGetResponse;

export const useGetIdeaQuery = <
  TData = GetIdeaQuery,
  TError = GetIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGetError,
>(
  { workspace_id, image_id, idea_id }: GetIdeaQueryVariables,
  options?: Omit<UseQueryOptions<GetIdeaQuery, TError, TData>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<GetIdeaQuery, TError, TData>({
    queryKey: ['GetIdea', { workspace_id, image_id, idea_id }],
    queryFn: async () => {
      const { data } = await getIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGet({
        path: { workspace_id, image_id, idea_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useGetIdeaQuery.getKey = ({ workspace_id, image_id, idea_id }: GetIdeaQueryVariables) => [
  'GetIdea',
  { workspace_id, image_id, idea_id },
];

useGetIdeaQuery.fetcher = (
  { workspace_id, image_id, idea_id }: GetIdeaQueryVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await getIdeaV1WorkspacesWorkspaceIdAssetsImagesImageIdIdeasIdeaIdGet({
      path: { workspace_id, image_id, idea_id },
      throwOnError: true,
    });
    return data;
  };
};
